import { get } from 'lodash';

import Model from 'models';
import Money from 'utils/Money';

const Variant = class extends Model {
  get id() {
    return get(this._data, 'id');
  }

  get sku() {
    return get(this._data, 'sku');
  }

  get value() {
    return get(this._data, 'value');
  }

  get available() {
    return get(this._data, 'available');
  }

  get backordered() {
    return get(this._data, 'backordered');
  }

  get isFinalSale() {
    return get(this._data, 'isFinalSale');
  }

  get price() {
    return get(this._data, 'price');
  }

  get handle() {
    return get(this._data, 'handle');
  }

  get formattedPrice() {
    return new Money(this.price).format();
  }

  get compareAtPrice() {
    return get(this._data, 'compareAtPrice');
  }

  get formattedCompareAtPrice() {
    if (!this.compareAtPrice) {
      return null;
    }
    return new Money(this.compareAtPrice).format();
  }

  get metafields() {
    return get(this._data, 'metafields');
  }
};

export default Variant;
